import Vue from "vue";
import Router from "vue-router";
import layout from "@com/layout";

Vue.use(Router);

export default new Router({

  scrollBehavior(/* to, from, savedPosition */) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 }
  },

  routes: [
    {
      path: '',
      redirect: '/home',
      component: layout,
      children: [
        {
          path: 'home',
          component: () => import('@v/home'),
          meta: {
            title: '首页'
          }
        },
        {
          path: 'detail',
          component: () => import('@v/detail'),
          meta: {
            title: '详情'
          }
        },
        {
          path: 'search',
          component: () => import('@v/search'),
          meta: {
            title: '搜索'
          }
        }
      ]
    }
  ]
});
